import { ErrorResponse } from "../../../utils";
import { State } from "./state";
import { Action as TAction, StoreDispatchProps } from "../../../Store";
import { Dispatch } from "redux";
import { actionCreator } from "../../../ajax";

export namespace Actions {
  // ACTION TYPES
  export const REQUEST_GET = "io/request/unix/get";
  export const REQUEST_POST = "io/request/unix/post";
  export const REQUEST_SYNC = "io/request/unix/sync";
  export const RESPONSE_GET = "io/response/unix/get";
  export const RESPONSE_POST = "io/response/unix/post";
  export const RESPONSE_SYNC = "io/response/unix/sync";
  export const POLL_START = "io/poll/unix/start";
  export const POLL_STOP = "io/poll/unix/stop";

  // ACTION INTERFACES
  type Requests = GetRequest | PostRequest;
  export interface GetRequest extends TAction<typeof REQUEST_GET> {}
  export interface PostRequest extends TAction<typeof REQUEST_POST> {
    data: Partial<State.Data>;
  }
  export interface SyncRequest extends TAction<typeof REQUEST_SYNC> {
    data: State.DataServer;
  }
  export interface GetResponse extends TAction<typeof RESPONSE_GET> {
    data: State.DataServer;
  }
  export interface PostResponse extends TAction<typeof RESPONSE_POST> {
    data: ErrorResponse;
  }
  export interface SyncResponse extends TAction<typeof RESPONSE_SYNC> {
    data: ErrorResponse;
  }
  export interface PollStart extends TAction<typeof POLL_START> {}
  export interface PollStop extends TAction<typeof POLL_STOP> {}
  export interface DispatchProps extends StoreDispatchProps<State.Data> {}

  // ACTIONS
  export const getRequest = actionCreator<GetRequest>(REQUEST_GET);
  export const getResponse = actionCreator<GetResponse>(RESPONSE_GET);
  export const postRequest = actionCreator<PostRequest>(REQUEST_POST);
  export const postResponse = actionCreator<PostResponse>(RESPONSE_POST);
  export const syncRequest = actionCreator<SyncRequest>(REQUEST_SYNC);
  export const syncResponse = actionCreator<SyncResponse>(RESPONSE_SYNC);
  export const pollStart = actionCreator<PollStart>(POLL_START);
  export const pollStop = actionCreator<PollStop>(POLL_STOP);
  export function fetchRequest(): GetRequest;
  export function fetchRequest(data: Partial<State.Data>): PostRequest;
  export function fetchRequest(data?: Partial<State.Data>): Requests {
    return data ? postRequest({ data }) : getRequest();
  }

  export const bindDispatchProps = (dispatch: Dispatch) => {
    return {
      fetch: (data?: Partial<State.Data>) =>
        dispatch(data ? fetchRequest(data) : fetchRequest()),
      poll: (p: boolean) =>
        dispatch(p ? pollStart({ data: p }) : pollStop({ data: p })),
      sync: () =>
        dispatch(syncRequest({ data: { unix: Math.round(Date.now() / 1000) } }))
    };
  };
}
export default Actions;
